import { IRVariantType } from '../types';

export const VERSIONS = [IRVariantType.VARIANT_A, IRVariantType.VARIANT_B];

export const LABEL_BY_VARIANT_KEY = {
  [IRVariantType.VARIANT_A]: 'Control',
  [IRVariantType.VARIANT_B]: 'Variant',
};
